<template>
  <div>
    <label :class="{ 'sr-only': hide_label }" :for="'input-' + id">{{ text }}</label>
    <b-form-select
      @change="emitToParent"
      v-model="value"
      :id="'input-' + id"
      :options="options"
    />
  </div>
</template>

<script>
export default {
  name: 'InputSelect',
  props: ['val', 'id', 'text', 'options', 'hide_label'],
  data () {
    return {
      value: this.val
    }
  },
  methods: {
    emitToParent: function () {
      this.$emit('passToParent', this.id, this.value)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/InputSelect/InputSelect.vue